import React, { Component } from 'react';
import Svg from './filter.svg';

export default class FilterIcon extends Component {
    render = () => {
        return (
            <img
                src={Svg}
                {...this.props}
                style={{ opacity: '0.7', marginLeft: '5px' }}
                alt="Filter Icon"
            />
        );
    };
}
